import React, { useMemo } from 'react';
import { PreparingView } from '@bingads-webui/ads-copilot-ui';
import { I18nModel } from '@bingads-webui/copilot-i18n';
import { getCopilotWidthFromPreference } from '@bingads-webui-react/copilot-resizer';

interface IMSAGlobalLoadingViewProps {
  onCopilotClose?(): void;
  i18n: I18nModel;
  classname?: string;
  isDynamicWidthEnabled?: boolean;
  preferenceService?: any;
}

export const MSAGlobalLoadingView: React.FC<IMSAGlobalLoadingViewProps> = React.memo(({
  onCopilotClose,
  i18n,
  preferenceService,
  classname,
  isDynamicWidthEnabled = false,
}) => {
  const width = useMemo(() => getCopilotWidthFromPreference(isDynamicWidthEnabled, preferenceService), [isDynamicWidthEnabled, preferenceService]);
  return (
    <div className={classname} style={{ width }}>
      <PreparingView
        onClose={onCopilotClose}
        showRefreshButton={false}
        loadingText={i18n.getString(_TL_('Preparing Copilot...'))}
      />
    </div>
  );
});
